import { useMutation } from "@tanstack/react-query";
import { useIntl } from "react-intl";
import { useParams } from "react-router-dom";
import { useApi } from "~hooks/apiHooks/useApi";
import { useNotification } from "~hooks/useNotification.ts";
import { defaultSeasonStageExportFieldNames } from "~pages/SeasonStages/SeasonStageListPage/constants/exportFields.ts";
import type { DefaultOperationSuccessResponse } from "~types/response.ts";

export const useExportSeasonStages = () => {
  const { sport = "", organizationId = "", seasonId = "" } = useParams();
  const { formatMessage } = useIntl();
  const request = useApi();
  const notification = useNotification();

  return useMutation<DefaultOperationSuccessResponse, Error, Array<string>>({
    mutationFn: async (fieldNames: Array<string>) =>
      await request(`${sport}/o/${organizationId}/seasons/${seasonId}/stages/export`, {
        method: "POST",
        body: {
          fieldNames: fieldNames || defaultSeasonStageExportFieldNames,
        },
      }),
    onSuccess: async (response: DefaultOperationSuccessResponse) => {
      if (response?.data && response.data.length > 0 && response.data[0]?.success) {
        notification.success({
          message: formatMessage({ id: "seasonStages.export.started" }),
          placement: "bottomRight",
        });
      }
    },
  });
};
